export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10580.df076bf6.jpg";